import type { ReactNode } from "react";
import { cn } from "../../utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const PanelFooter = ({ children, className }: Props) => {
  return (
    <footer
      data-panel-footer
      className={cn("w-full p-4 border-t border-neutral-500/10", className)}
    >
      {children}
    </footer>
  );
};
